/*!
 * perfect-scrollbar v1.5.6
 * Copyright 2024 Hyunje Jun, MDBootstrap and Contributors
 * Licensed under MIT
 */ function $53143b210d847066$var$get(element) {
    return getComputedStyle(element);
}
function $53143b210d847066$var$set(element, obj) {
    for(var key in obj){
        var val = obj[key];
        if (typeof val === 'number') val = val + "px";
        element.style[key] = val;
    }
    return element;
}
function $53143b210d847066$var$div(className) {
    var div = document.createElement('div');
    div.className = className;
    return div;
}
var $53143b210d847066$var$elMatches = typeof Element !== 'undefined' && (Element.prototype.matches || Element.prototype.webkitMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector);
function $53143b210d847066$var$matches(element, query) {
    if (!$53143b210d847066$var$elMatches) throw new Error('No element matching method supported');
    return $53143b210d847066$var$elMatches.call(element, query);
}
function $53143b210d847066$var$remove(element) {
    if (element.remove) element.remove();
    else if (element.parentNode) element.parentNode.removeChild(element);
}
function $53143b210d847066$var$queryChildren(element, selector) {
    return Array.prototype.filter.call(element.children, function(child) {
        return $53143b210d847066$var$matches(child, selector);
    });
}
var $53143b210d847066$var$cls = {
    main: 'ps',
    rtl: 'ps__rtl',
    element: {
        thumb: function(x) {
            return "ps__thumb-" + x;
        },
        rail: function(x) {
            return "ps__rail-" + x;
        },
        consuming: 'ps__child--consume'
    },
    state: {
        focus: 'ps--focus',
        clicking: 'ps--clicking',
        active: function(x) {
            return "ps--active-" + x;
        },
        scrolling: function(x) {
            return "ps--scrolling-" + x;
        }
    }
};
/*
 * Helper methods
 */ var $53143b210d847066$var$scrollingClassTimeout = {
    x: null,
    y: null
};
function $53143b210d847066$var$addScrollingClass(i, x) {
    var classList = i.element.classList;
    var className = $53143b210d847066$var$cls.state.scrolling(x);
    if (classList.contains(className)) clearTimeout($53143b210d847066$var$scrollingClassTimeout[x]);
    else classList.add(className);
}
function $53143b210d847066$var$removeScrollingClass(i, x) {
    $53143b210d847066$var$scrollingClassTimeout[x] = setTimeout(function() {
        return i.isAlive && i.element.classList.remove($53143b210d847066$var$cls.state.scrolling(x));
    }, i.settings.scrollingThreshold);
}
function $53143b210d847066$var$setScrollingClassInstantly(i, x) {
    $53143b210d847066$var$addScrollingClass(i, x);
    $53143b210d847066$var$removeScrollingClass(i, x);
}
var $53143b210d847066$var$EventElement = function EventElement(element) {
    this.element = element;
    this.handlers = {};
};
var $53143b210d847066$var$prototypeAccessors = {
    isEmpty: {
        configurable: true
    }
};
$53143b210d847066$var$EventElement.prototype.bind = function bind(eventName, handler) {
    if (typeof this.handlers[eventName] === 'undefined') this.handlers[eventName] = [];
    this.handlers[eventName].push(handler);
    this.element.addEventListener(eventName, handler, false);
};
$53143b210d847066$var$EventElement.prototype.unbind = function unbind(eventName, target) {
    var this$1 = this;
    this.handlers[eventName] = this.handlers[eventName].filter(function(handler) {
        if (target && handler !== target) return true;
        this$1.element.removeEventListener(eventName, handler, false);
        return false;
    });
};
$53143b210d847066$var$EventElement.prototype.unbindAll = function unbindAll() {
    for(var name in this.handlers)this.unbind(name);
};
$53143b210d847066$var$prototypeAccessors.isEmpty.get = function() {
    var this$1 = this;
    return Object.keys(this.handlers).every(function(key) {
        return this$1.handlers[key].length === 0;
    });
};
Object.defineProperties($53143b210d847066$var$EventElement.prototype, $53143b210d847066$var$prototypeAccessors);
var $53143b210d847066$var$EventManager = function EventManager() {
    this.eventElements = [];
};
$53143b210d847066$var$EventManager.prototype.eventElement = function eventElement(element) {
    var ee = this.eventElements.filter(function(ee) {
        return ee.element === element;
    })[0];
    if (!ee) {
        ee = new $53143b210d847066$var$EventElement(element);
        this.eventElements.push(ee);
    }
    return ee;
};
$53143b210d847066$var$EventManager.prototype.bind = function bind(element, eventName, handler) {
    this.eventElement(element).bind(eventName, handler);
};
$53143b210d847066$var$EventManager.prototype.unbind = function unbind(element, eventName, handler) {
    var ee = this.eventElement(element);
    ee.unbind(eventName, handler);
    if (ee.isEmpty) // remove
    this.eventElements.splice(this.eventElements.indexOf(ee), 1);
};
$53143b210d847066$var$EventManager.prototype.unbindAll = function unbindAll() {
    this.eventElements.forEach(function(e) {
        return e.unbindAll();
    });
    this.eventElements = [];
};
$53143b210d847066$var$EventManager.prototype.once = function once(element, eventName, handler) {
    var ee = this.eventElement(element);
    var onceHandler = function(evt) {
        ee.unbind(eventName, onceHandler);
        handler(evt);
    };
    ee.bind(eventName, onceHandler);
};
function $53143b210d847066$var$createEvent(name) {
    if (typeof window.CustomEvent === 'function') return new CustomEvent(name);
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(name, false, false, undefined);
    return evt;
}
function $53143b210d847066$var$processScrollDiff(i, axis, diff, useScrollingClass, forceFireReachEvent) {
    if (useScrollingClass === void 0) useScrollingClass = true;
    if (forceFireReachEvent === void 0) forceFireReachEvent = false;
    var fields;
    if (axis === 'top') fields = [
        'contentHeight',
        'containerHeight',
        'scrollTop',
        'y',
        'up',
        'down'
    ];
    else if (axis === 'left') fields = [
        'contentWidth',
        'containerWidth',
        'scrollLeft',
        'x',
        'left',
        'right'
    ];
    else throw new Error('A proper axis should be provided');
    $53143b210d847066$var$processScrollDiff$1(i, diff, fields, useScrollingClass, forceFireReachEvent);
}
function $53143b210d847066$var$processScrollDiff$1(i, diff, ref, useScrollingClass, forceFireReachEvent) {
    var contentHeight = ref[0];
    var containerHeight = ref[1];
    var scrollTop = ref[2];
    var y = ref[3];
    var up = ref[4];
    var down = ref[5];
    if (useScrollingClass === void 0) useScrollingClass = true;
    if (forceFireReachEvent === void 0) forceFireReachEvent = false;
    var element = i.element;
    // reset reach
    i.reach[y] = null;
    // 1 for subpixel rounding
    if (element[scrollTop] < 1) i.reach[y] = 'start';
    // 1 for subpixel rounding
    if (element[scrollTop] > i[contentHeight] - i[containerHeight] - 1) i.reach[y] = 'end';
    if (diff) {
        element.dispatchEvent($53143b210d847066$var$createEvent("ps-scroll-" + y));
        if (diff < 0) element.dispatchEvent($53143b210d847066$var$createEvent("ps-scroll-" + up));
        else if (diff > 0) element.dispatchEvent($53143b210d847066$var$createEvent("ps-scroll-" + down));
        if (useScrollingClass) $53143b210d847066$var$setScrollingClassInstantly(i, y);
    }
    if (i.reach[y] && (diff || forceFireReachEvent)) element.dispatchEvent($53143b210d847066$var$createEvent("ps-" + y + "-reach-" + i.reach[y]));
}
function $53143b210d847066$var$toInt(x) {
    return parseInt(x, 10) || 0;
}
function $53143b210d847066$var$isEditable(el) {
    return $53143b210d847066$var$matches(el, 'input,[contenteditable]') || $53143b210d847066$var$matches(el, 'select,[contenteditable]') || $53143b210d847066$var$matches(el, 'textarea,[contenteditable]') || $53143b210d847066$var$matches(el, 'button,[contenteditable]');
}
function $53143b210d847066$var$outerWidth(element) {
    var styles = $53143b210d847066$var$get(element);
    return $53143b210d847066$var$toInt(styles.width) + $53143b210d847066$var$toInt(styles.paddingLeft) + $53143b210d847066$var$toInt(styles.paddingRight) + $53143b210d847066$var$toInt(styles.borderLeftWidth) + $53143b210d847066$var$toInt(styles.borderRightWidth);
}
var $53143b210d847066$var$env = {
    isWebKit: typeof document !== 'undefined' && 'WebkitAppearance' in document.documentElement.style,
    supportsTouch: typeof window !== 'undefined' && ('ontouchstart' in window || 'maxTouchPoints' in window.navigator && window.navigator.maxTouchPoints > 0 || window.DocumentTouch && document instanceof window.DocumentTouch),
    supportsIePointer: typeof navigator !== 'undefined' && navigator.msMaxTouchPoints,
    isChrome: typeof navigator !== 'undefined' && /Chrome/i.test(navigator && navigator.userAgent)
};
/* eslint-disable no-lonely-if */ function $53143b210d847066$var$updateGeometry(i) {
    var element = i.element;
    var roundedScrollTop = Math.floor(element.scrollTop);
    var rect = element.getBoundingClientRect();
    i.containerWidth = Math.floor(rect.width);
    i.containerHeight = Math.floor(rect.height);
    i.contentWidth = element.scrollWidth;
    i.contentHeight = element.scrollHeight;
    if (!element.contains(i.scrollbarXRail)) {
        // clean up and append
        $53143b210d847066$var$queryChildren(element, $53143b210d847066$var$cls.element.rail('x')).forEach(function(el) {
            return $53143b210d847066$var$remove(el);
        });
        element.appendChild(i.scrollbarXRail);
    }
    if (!element.contains(i.scrollbarYRail)) {
        // clean up and append
        $53143b210d847066$var$queryChildren(element, $53143b210d847066$var$cls.element.rail('y')).forEach(function(el) {
            return $53143b210d847066$var$remove(el);
        });
        element.appendChild(i.scrollbarYRail);
    }
    if (!i.settings.suppressScrollX && i.containerWidth + i.settings.scrollXMarginOffset < i.contentWidth) {
        i.scrollbarXActive = true;
        i.railXWidth = i.containerWidth - i.railXMarginWidth;
        i.railXRatio = i.containerWidth / i.railXWidth;
        i.scrollbarXWidth = $53143b210d847066$var$getThumbSize(i, $53143b210d847066$var$toInt(i.railXWidth * i.containerWidth / i.contentWidth));
        i.scrollbarXLeft = $53143b210d847066$var$toInt((i.negativeScrollAdjustment + element.scrollLeft) * (i.railXWidth - i.scrollbarXWidth) / (i.contentWidth - i.containerWidth));
    } else i.scrollbarXActive = false;
    if (!i.settings.suppressScrollY && i.containerHeight + i.settings.scrollYMarginOffset < i.contentHeight) {
        i.scrollbarYActive = true;
        i.railYHeight = i.containerHeight - i.railYMarginHeight;
        i.railYRatio = i.containerHeight / i.railYHeight;
        i.scrollbarYHeight = $53143b210d847066$var$getThumbSize(i, $53143b210d847066$var$toInt(i.railYHeight * i.containerHeight / i.contentHeight));
        i.scrollbarYTop = $53143b210d847066$var$toInt(roundedScrollTop * (i.railYHeight - i.scrollbarYHeight) / (i.contentHeight - i.containerHeight));
    } else i.scrollbarYActive = false;
    if (i.scrollbarXLeft >= i.railXWidth - i.scrollbarXWidth) i.scrollbarXLeft = i.railXWidth - i.scrollbarXWidth;
    if (i.scrollbarYTop >= i.railYHeight - i.scrollbarYHeight) i.scrollbarYTop = i.railYHeight - i.scrollbarYHeight;
    $53143b210d847066$var$updateCss(element, i);
    if (i.scrollbarXActive) element.classList.add($53143b210d847066$var$cls.state.active('x'));
    else {
        element.classList.remove($53143b210d847066$var$cls.state.active('x'));
        i.scrollbarXWidth = 0;
        i.scrollbarXLeft = 0;
        element.scrollLeft = i.isRtl === true ? i.contentWidth : 0;
    }
    if (i.scrollbarYActive) element.classList.add($53143b210d847066$var$cls.state.active('y'));
    else {
        element.classList.remove($53143b210d847066$var$cls.state.active('y'));
        i.scrollbarYHeight = 0;
        i.scrollbarYTop = 0;
        element.scrollTop = 0;
    }
}
function $53143b210d847066$var$getThumbSize(i, thumbSize) {
    if (i.settings.minScrollbarLength) thumbSize = Math.max(thumbSize, i.settings.minScrollbarLength);
    if (i.settings.maxScrollbarLength) thumbSize = Math.min(thumbSize, i.settings.maxScrollbarLength);
    return thumbSize;
}
function $53143b210d847066$var$updateCss(element, i) {
    var xRailOffset = {
        width: i.railXWidth
    };
    var roundedScrollTop = Math.floor(element.scrollTop);
    if (i.isRtl) xRailOffset.left = i.negativeScrollAdjustment + element.scrollLeft + i.containerWidth - i.contentWidth;
    else xRailOffset.left = element.scrollLeft;
    if (i.isScrollbarXUsingBottom) xRailOffset.bottom = i.scrollbarXBottom - roundedScrollTop;
    else xRailOffset.top = i.scrollbarXTop + roundedScrollTop;
    $53143b210d847066$var$set(i.scrollbarXRail, xRailOffset);
    var yRailOffset = {
        top: roundedScrollTop,
        height: i.railYHeight
    };
    if (i.isScrollbarYUsingRight) {
        if (i.isRtl) yRailOffset.right = i.contentWidth - (i.negativeScrollAdjustment + element.scrollLeft) - i.scrollbarYRight - i.scrollbarYOuterWidth - 9;
        else yRailOffset.right = i.scrollbarYRight - element.scrollLeft;
    } else if (i.isRtl) yRailOffset.left = i.negativeScrollAdjustment + element.scrollLeft + i.containerWidth * 2 - i.contentWidth - i.scrollbarYLeft - i.scrollbarYOuterWidth;
    else yRailOffset.left = i.scrollbarYLeft + element.scrollLeft;
    $53143b210d847066$var$set(i.scrollbarYRail, yRailOffset);
    $53143b210d847066$var$set(i.scrollbarX, {
        left: i.scrollbarXLeft,
        width: i.scrollbarXWidth - i.railBorderXWidth
    });
    $53143b210d847066$var$set(i.scrollbarY, {
        top: i.scrollbarYTop,
        height: i.scrollbarYHeight - i.railBorderYWidth
    });
}
/* eslint-disable */ function $53143b210d847066$var$clickRail(i) {
    // const element = i.element;
    i.event.bind(i.scrollbarY, 'mousedown', function(e) {
        return e.stopPropagation();
    });
    i.event.bind(i.scrollbarYRail, 'mousedown', function(e) {
        var positionTop = e.pageY - window.pageYOffset - i.scrollbarYRail.getBoundingClientRect().top;
        var direction = positionTop > i.scrollbarYTop ? 1 : -1;
        i.element.scrollTop += direction * i.containerHeight;
        $53143b210d847066$var$updateGeometry(i);
        e.stopPropagation();
    });
    i.event.bind(i.scrollbarX, 'mousedown', function(e) {
        return e.stopPropagation();
    });
    i.event.bind(i.scrollbarXRail, 'mousedown', function(e) {
        var positionLeft = e.pageX - window.pageXOffset - i.scrollbarXRail.getBoundingClientRect().left;
        var direction = positionLeft > i.scrollbarXLeft ? 1 : -1;
        i.element.scrollLeft += direction * i.containerWidth;
        $53143b210d847066$var$updateGeometry(i);
        e.stopPropagation();
    });
}
var $53143b210d847066$var$activeSlider = null; // Variable to track the currently active slider
function $53143b210d847066$var$setupScrollHandlers(i) {
    $53143b210d847066$var$bindMouseScrollHandler(i, [
        'containerHeight',
        'contentHeight',
        'pageY',
        'railYHeight',
        'scrollbarY',
        'scrollbarYHeight',
        'scrollTop',
        'y',
        'scrollbarYRail'
    ]);
    $53143b210d847066$var$bindMouseScrollHandler(i, [
        'containerWidth',
        'contentWidth',
        'pageX',
        'railXWidth',
        'scrollbarX',
        'scrollbarXWidth',
        'scrollLeft',
        'x',
        'scrollbarXRail'
    ]);
}
function $53143b210d847066$var$bindMouseScrollHandler(i, ref) {
    var containerDimension = ref[0];
    var contentDimension = ref[1];
    var pageAxis = ref[2];
    var railDimension = ref[3];
    var scrollbarAxis = ref[4];
    var scrollbarDimension = ref[5];
    var scrollAxis = ref[6];
    var axis = ref[7];
    var scrollbarRail = ref[8];
    var element = i.element;
    var startingScrollPosition = null;
    var startingMousePagePosition = null;
    var scrollBy = null;
    function moveHandler(e) {
        if (e.touches && e.touches[0]) e[pageAxis] = e.touches[0]["page" + axis.toUpperCase()];
        // Only move if the active slider is the one we started with
        if ($53143b210d847066$var$activeSlider === scrollbarAxis) {
            element[scrollAxis] = startingScrollPosition + scrollBy * (e[pageAxis] - startingMousePagePosition);
            $53143b210d847066$var$addScrollingClass(i, axis);
            $53143b210d847066$var$updateGeometry(i);
            e.stopPropagation();
            e.preventDefault();
        }
    }
    function endHandler() {
        $53143b210d847066$var$removeScrollingClass(i, axis);
        i[scrollbarRail].classList.remove($53143b210d847066$var$cls.state.clicking);
        document.removeEventListener('mousemove', moveHandler);
        document.removeEventListener('mouseup', endHandler);
        document.removeEventListener('touchmove', moveHandler);
        document.removeEventListener('touchend', endHandler);
        $53143b210d847066$var$activeSlider = null; // Reset active slider when interaction ends
    }
    function bindMoves(e) {
        if ($53143b210d847066$var$activeSlider === null) {
            // Only bind if no slider is currently active
            $53143b210d847066$var$activeSlider = scrollbarAxis; // Set current slider as active
            startingScrollPosition = element[scrollAxis];
            if (e.touches) e[pageAxis] = e.touches[0]["page" + axis.toUpperCase()];
            startingMousePagePosition = e[pageAxis];
            scrollBy = (i[contentDimension] - i[containerDimension]) / (i[railDimension] - i[scrollbarDimension]);
            if (!e.touches) {
                document.addEventListener('mousemove', moveHandler);
                document.addEventListener('mouseup', endHandler);
            } else {
                document.addEventListener('touchmove', moveHandler, {
                    passive: false
                });
                document.addEventListener('touchend', endHandler);
            }
            i[scrollbarRail].classList.add($53143b210d847066$var$cls.state.clicking);
        }
        e.stopPropagation();
        if (e.cancelable) e.preventDefault();
    }
    i[scrollbarAxis].addEventListener('mousedown', bindMoves);
    i[scrollbarAxis].addEventListener('touchstart', bindMoves);
}
/* eslint-disable */ function $53143b210d847066$var$keyboard(i) {
    var element = i.element;
    var elementHovered = function() {
        return $53143b210d847066$var$matches(element, ':hover');
    };
    var scrollbarFocused = function() {
        return $53143b210d847066$var$matches(i.scrollbarX, ':focus') || $53143b210d847066$var$matches(i.scrollbarY, ':focus');
    };
    function shouldPreventDefault(deltaX, deltaY) {
        var scrollTop = Math.floor(element.scrollTop);
        if (deltaX === 0) {
            if (!i.scrollbarYActive) return false;
            if (scrollTop === 0 && deltaY > 0 || scrollTop >= i.contentHeight - i.containerHeight && deltaY < 0) return !i.settings.wheelPropagation;
        }
        var scrollLeft = element.scrollLeft;
        if (deltaY === 0) {
            if (!i.scrollbarXActive) return false;
            if (scrollLeft === 0 && deltaX < 0 || scrollLeft >= i.contentWidth - i.containerWidth && deltaX > 0) return !i.settings.wheelPropagation;
        }
        return true;
    }
    i.event.bind(i.ownerDocument, 'keydown', function(e) {
        if (e.isDefaultPrevented && e.isDefaultPrevented() || e.defaultPrevented) return;
        if (!elementHovered() && !scrollbarFocused()) return;
        var activeElement = document.activeElement ? document.activeElement : i.ownerDocument.activeElement;
        if (activeElement) {
            if (activeElement.tagName === 'IFRAME') activeElement = activeElement.contentDocument.activeElement;
            else // go deeper if element is a webcomponent
            while(activeElement.shadowRoot)activeElement = activeElement.shadowRoot.activeElement;
            if ($53143b210d847066$var$isEditable(activeElement)) return;
        }
        var deltaX = 0;
        var deltaY = 0;
        switch(e.which){
            case 37:
                if (e.metaKey) deltaX = -i.contentWidth;
                else if (e.altKey) deltaX = -i.containerWidth;
                else deltaX = -30;
                break;
            case 38:
                if (e.metaKey) deltaY = i.contentHeight;
                else if (e.altKey) deltaY = i.containerHeight;
                else deltaY = 30;
                break;
            case 39:
                if (e.metaKey) deltaX = i.contentWidth;
                else if (e.altKey) deltaX = i.containerWidth;
                else deltaX = 30;
                break;
            case 40:
                if (e.metaKey) deltaY = -i.contentHeight;
                else if (e.altKey) deltaY = -i.containerHeight;
                else deltaY = -30;
                break;
            case 32:
                if (e.shiftKey) deltaY = i.containerHeight;
                else deltaY = -i.containerHeight;
                break;
            case 33:
                deltaY = i.containerHeight;
                break;
            case 34:
                deltaY = -i.containerHeight;
                break;
            case 36:
                deltaY = i.contentHeight;
                break;
            case 35:
                deltaY = -i.contentHeight;
                break;
            default:
                return;
        }
        if (i.settings.suppressScrollX && deltaX !== 0) return;
        if (i.settings.suppressScrollY && deltaY !== 0) return;
        element.scrollTop -= deltaY;
        element.scrollLeft += deltaX;
        $53143b210d847066$var$updateGeometry(i);
        if (shouldPreventDefault(deltaX, deltaY)) e.preventDefault();
    });
}
/* eslint-disable */ function $53143b210d847066$var$wheel(i) {
    var element = i.element;
    function shouldPreventDefault(deltaX, deltaY) {
        var roundedScrollTop = Math.floor(element.scrollTop);
        var isTop = element.scrollTop === 0;
        var isBottom = roundedScrollTop + element.offsetHeight === element.scrollHeight;
        var isLeft = element.scrollLeft === 0;
        var isRight = element.scrollLeft + element.offsetWidth === element.scrollWidth;
        var hitsBound;
        // pick axis with primary direction
        if (Math.abs(deltaY) > Math.abs(deltaX)) hitsBound = isTop || isBottom;
        else hitsBound = isLeft || isRight;
        return hitsBound ? !i.settings.wheelPropagation : true;
    }
    function getDeltaFromEvent(e) {
        var deltaX = e.deltaX;
        var deltaY = -1 * e.deltaY;
        if (typeof deltaX === 'undefined' || typeof deltaY === 'undefined') {
            // OS X Safari
            deltaX = -1 * e.wheelDeltaX / 6;
            deltaY = e.wheelDeltaY / 6;
        }
        if (e.deltaMode && e.deltaMode === 1) {
            // Firefox in deltaMode 1: Line scrolling
            deltaX *= 10;
            deltaY *= 10;
        }
        if (deltaX !== deltaX && deltaY !== deltaY /* NaN checks */ ) {
            // IE in some mouse drivers
            deltaX = 0;
            deltaY = e.wheelDelta;
        }
        if (e.shiftKey) // reverse axis with shift key
        return [
            -deltaY,
            -deltaX
        ];
        return [
            deltaX,
            deltaY
        ];
    }
    function shouldBeConsumedByChild(target, deltaX, deltaY) {
        // FIXME: this is a workaround for <select> issue in FF and IE #571
        if (!$53143b210d847066$var$env.isWebKit && element.querySelector('select:focus')) return true;
        if (!element.contains(target)) return false;
        var cursor = target;
        while(cursor && cursor !== element){
            if (cursor.classList.contains($53143b210d847066$var$cls.element.consuming)) return true;
            var style = $53143b210d847066$var$get(cursor);
            // if deltaY && vertical scrollable
            if (deltaY && style.overflowY.match(/(scroll|auto)/)) {
                var maxScrollTop = cursor.scrollHeight - cursor.clientHeight;
                if (maxScrollTop > 0) {
                    if (cursor.scrollTop > 0 && deltaY < 0 || cursor.scrollTop < maxScrollTop && deltaY > 0) return true;
                }
            }
            // if deltaX && horizontal scrollable
            if (deltaX && style.overflowX.match(/(scroll|auto)/)) {
                var maxScrollLeft = cursor.scrollWidth - cursor.clientWidth;
                if (maxScrollLeft > 0) {
                    if (cursor.scrollLeft > 0 && deltaX < 0 || cursor.scrollLeft < maxScrollLeft && deltaX > 0) return true;
                }
            }
            cursor = cursor.parentNode;
        }
        return false;
    }
    function mousewheelHandler(e) {
        var ref = getDeltaFromEvent(e);
        var deltaX = ref[0];
        var deltaY = ref[1];
        if (shouldBeConsumedByChild(e.target, deltaX, deltaY)) return;
        var shouldPrevent = false;
        if (!i.settings.useBothWheelAxes) {
            // deltaX will only be used for horizontal scrolling and deltaY will
            // only be used for vertical scrolling - this is the default
            element.scrollTop -= deltaY * i.settings.wheelSpeed;
            element.scrollLeft += deltaX * i.settings.wheelSpeed;
        } else if (i.scrollbarYActive && !i.scrollbarXActive) {
            // only vertical scrollbar is active and useBothWheelAxes option is
            // active, so let's scroll vertical bar using both mouse wheel axes
            if (deltaY) element.scrollTop -= deltaY * i.settings.wheelSpeed;
            else element.scrollTop += deltaX * i.settings.wheelSpeed;
            shouldPrevent = true;
        } else if (i.scrollbarXActive && !i.scrollbarYActive) {
            // useBothWheelAxes and only horizontal bar is active, so use both
            // wheel axes for horizontal bar
            if (deltaX) element.scrollLeft += deltaX * i.settings.wheelSpeed;
            else element.scrollLeft -= deltaY * i.settings.wheelSpeed;
            shouldPrevent = true;
        }
        $53143b210d847066$var$updateGeometry(i);
        shouldPrevent = shouldPrevent || shouldPreventDefault(deltaX, deltaY);
        if (shouldPrevent && !e.ctrlKey) {
            e.stopPropagation();
            e.preventDefault();
        }
    }
    if (typeof window.onwheel !== 'undefined') i.event.bind(element, 'wheel', mousewheelHandler);
    else if (typeof window.onmousewheel !== 'undefined') i.event.bind(element, 'mousewheel', mousewheelHandler);
}
function $53143b210d847066$var$touch(i) {
    if (!$53143b210d847066$var$env.supportsTouch && !$53143b210d847066$var$env.supportsIePointer) return;
    var element = i.element;
    var state = {
        startOffset: {},
        startTime: 0,
        speed: {},
        easingLoop: null
    };
    function shouldPrevent(deltaX, deltaY) {
        var scrollTop = Math.floor(element.scrollTop);
        var scrollLeft = element.scrollLeft;
        var magnitudeX = Math.abs(deltaX);
        var magnitudeY = Math.abs(deltaY);
        if (magnitudeY > magnitudeX) {
            // user is perhaps trying to swipe up/down the page
            if (deltaY < 0 && scrollTop === i.contentHeight - i.containerHeight || deltaY > 0 && scrollTop === 0) // set prevent for mobile Chrome refresh
            return window.scrollY === 0 && deltaY > 0 && $53143b210d847066$var$env.isChrome;
        } else if (magnitudeX > magnitudeY) {
            // user is perhaps trying to swipe left/right across the page
            if (deltaX < 0 && scrollLeft === i.contentWidth - i.containerWidth || deltaX > 0 && scrollLeft === 0) return true;
        }
        return true;
    }
    function applyTouchMove(differenceX, differenceY) {
        element.scrollTop -= differenceY;
        element.scrollLeft -= differenceX;
        $53143b210d847066$var$updateGeometry(i);
    }
    function getTouch(e) {
        if (e.targetTouches) return e.targetTouches[0];
        // Maybe IE pointer
        return e;
    }
    function shouldHandle(e) {
        if (e.target === i.scrollbarX || e.target === i.scrollbarY) return false;
        if (e.pointerType && e.pointerType === 'pen' && e.buttons === 0) return false;
        if (e.targetTouches && e.targetTouches.length === 1) return true;
        if (e.pointerType && e.pointerType !== 'mouse' && e.pointerType !== e.MSPOINTER_TYPE_MOUSE) return true;
        return false;
    }
    function touchStart(e) {
        if (!shouldHandle(e)) return;
        var touch = getTouch(e);
        state.startOffset.pageX = touch.pageX;
        state.startOffset.pageY = touch.pageY;
        state.startTime = new Date().getTime();
        if (state.easingLoop !== null) clearInterval(state.easingLoop);
    }
    function shouldBeConsumedByChild(target, deltaX, deltaY) {
        if (!element.contains(target)) return false;
        var cursor = target;
        while(cursor && cursor !== element){
            if (cursor.classList.contains($53143b210d847066$var$cls.element.consuming)) return true;
            var style = $53143b210d847066$var$get(cursor);
            // if deltaY && vertical scrollable
            if (deltaY && style.overflowY.match(/(scroll|auto)/)) {
                var maxScrollTop = cursor.scrollHeight - cursor.clientHeight;
                if (maxScrollTop > 0) {
                    if (cursor.scrollTop > 0 && deltaY < 0 || cursor.scrollTop < maxScrollTop && deltaY > 0) return true;
                }
            }
            // if deltaX && horizontal scrollable
            if (deltaX && style.overflowX.match(/(scroll|auto)/)) {
                var maxScrollLeft = cursor.scrollWidth - cursor.clientWidth;
                if (maxScrollLeft > 0) {
                    if (cursor.scrollLeft > 0 && deltaX < 0 || cursor.scrollLeft < maxScrollLeft && deltaX > 0) return true;
                }
            }
            cursor = cursor.parentNode;
        }
        return false;
    }
    function touchMove(e) {
        if (shouldHandle(e)) {
            var touch = getTouch(e);
            var currentOffset = {
                pageX: touch.pageX,
                pageY: touch.pageY
            };
            var differenceX = currentOffset.pageX - state.startOffset.pageX;
            var differenceY = currentOffset.pageY - state.startOffset.pageY;
            if (shouldBeConsumedByChild(e.target, differenceX, differenceY)) return;
            applyTouchMove(differenceX, differenceY);
            state.startOffset = currentOffset;
            var currentTime = new Date().getTime();
            var timeGap = currentTime - state.startTime;
            if (timeGap > 0) {
                state.speed.x = differenceX / timeGap;
                state.speed.y = differenceY / timeGap;
                state.startTime = currentTime;
            }
            if (shouldPrevent(differenceX, differenceY)) // Prevent the default behavior if the event is cancelable
            {
                if (e.cancelable) e.preventDefault();
            }
        }
    }
    function touchEnd() {
        if (i.settings.swipeEasing) {
            clearInterval(state.easingLoop);
            state.easingLoop = setInterval(function() {
                if (i.isInitialized) {
                    clearInterval(state.easingLoop);
                    return;
                }
                if (!state.speed.x && !state.speed.y) {
                    clearInterval(state.easingLoop);
                    return;
                }
                if (Math.abs(state.speed.x) < 0.01 && Math.abs(state.speed.y) < 0.01) {
                    clearInterval(state.easingLoop);
                    return;
                }
                applyTouchMove(state.speed.x * 30, state.speed.y * 30);
                state.speed.x *= 0.8;
                state.speed.y *= 0.8;
            }, 10);
        }
    }
    if ($53143b210d847066$var$env.supportsTouch) {
        i.event.bind(element, 'touchstart', touchStart);
        i.event.bind(element, 'touchmove', touchMove);
        i.event.bind(element, 'touchend', touchEnd);
    } else if ($53143b210d847066$var$env.supportsIePointer) {
        if (window.PointerEvent) {
            i.event.bind(element, 'pointerdown', touchStart);
            i.event.bind(element, 'pointermove', touchMove);
            i.event.bind(element, 'pointerup', touchEnd);
        } else if (window.MSPointerEvent) {
            i.event.bind(element, 'MSPointerDown', touchStart);
            i.event.bind(element, 'MSPointerMove', touchMove);
            i.event.bind(element, 'MSPointerUp', touchEnd);
        }
    }
}
/* eslint-disable */ var $53143b210d847066$var$defaultSettings = function() {
    return {
        handlers: [
            'click-rail',
            'drag-thumb',
            'keyboard',
            'wheel',
            'touch'
        ],
        maxScrollbarLength: null,
        minScrollbarLength: null,
        scrollingThreshold: 1000,
        scrollXMarginOffset: 0,
        scrollYMarginOffset: 0,
        suppressScrollX: false,
        suppressScrollY: false,
        swipeEasing: true,
        useBothWheelAxes: false,
        wheelPropagation: true,
        wheelSpeed: 1
    };
};
var $53143b210d847066$var$handlers = {
    'click-rail': $53143b210d847066$var$clickRail,
    'drag-thumb': $53143b210d847066$var$setupScrollHandlers,
    keyboard: $53143b210d847066$var$keyboard,
    wheel: $53143b210d847066$var$wheel,
    touch: $53143b210d847066$var$touch
};
var $53143b210d847066$var$PerfectScrollbar = function PerfectScrollbar(element, userSettings) {
    var this$1 = this;
    if (userSettings === void 0) userSettings = {};
    if (typeof element === 'string') element = document.querySelector(element);
    if (!element || !element.nodeName) throw new Error('no element is specified to initialize PerfectScrollbar');
    this.element = element;
    element.classList.add($53143b210d847066$var$cls.main);
    this.settings = $53143b210d847066$var$defaultSettings();
    for(var key in userSettings)this.settings[key] = userSettings[key];
    this.containerWidth = null;
    this.containerHeight = null;
    this.contentWidth = null;
    this.contentHeight = null;
    var focus = function() {
        return element.classList.add($53143b210d847066$var$cls.state.focus);
    };
    var blur = function() {
        return element.classList.remove($53143b210d847066$var$cls.state.focus);
    };
    this.isRtl = $53143b210d847066$var$get(element).direction === 'rtl';
    if (this.isRtl === true) element.classList.add($53143b210d847066$var$cls.rtl);
    this.isNegativeScroll = function() {
        var originalScrollLeft = element.scrollLeft;
        var result = null;
        element.scrollLeft = -1;
        result = element.scrollLeft < 0;
        element.scrollLeft = originalScrollLeft;
        return result;
    }();
    this.negativeScrollAdjustment = this.isNegativeScroll ? element.scrollWidth - element.clientWidth : 0;
    this.event = new $53143b210d847066$var$EventManager();
    this.ownerDocument = element.ownerDocument || document;
    this.scrollbarXRail = $53143b210d847066$var$div($53143b210d847066$var$cls.element.rail('x'));
    element.appendChild(this.scrollbarXRail);
    this.scrollbarX = $53143b210d847066$var$div($53143b210d847066$var$cls.element.thumb('x'));
    this.scrollbarXRail.appendChild(this.scrollbarX);
    this.scrollbarX.setAttribute('tabindex', 0);
    this.event.bind(this.scrollbarX, 'focus', focus);
    this.event.bind(this.scrollbarX, 'blur', blur);
    this.scrollbarXActive = null;
    this.scrollbarXWidth = null;
    this.scrollbarXLeft = null;
    var railXStyle = $53143b210d847066$var$get(this.scrollbarXRail);
    this.scrollbarXBottom = parseInt(railXStyle.bottom, 10);
    if (isNaN(this.scrollbarXBottom)) {
        this.isScrollbarXUsingBottom = false;
        this.scrollbarXTop = $53143b210d847066$var$toInt(railXStyle.top);
    } else this.isScrollbarXUsingBottom = true;
    this.railBorderXWidth = $53143b210d847066$var$toInt(railXStyle.borderLeftWidth) + $53143b210d847066$var$toInt(railXStyle.borderRightWidth);
    // Set rail to display:block to calculate margins
    $53143b210d847066$var$set(this.scrollbarXRail, {
        display: 'block'
    });
    this.railXMarginWidth = $53143b210d847066$var$toInt(railXStyle.marginLeft) + $53143b210d847066$var$toInt(railXStyle.marginRight);
    $53143b210d847066$var$set(this.scrollbarXRail, {
        display: ''
    });
    this.railXWidth = null;
    this.railXRatio = null;
    this.scrollbarYRail = $53143b210d847066$var$div($53143b210d847066$var$cls.element.rail('y'));
    element.appendChild(this.scrollbarYRail);
    this.scrollbarY = $53143b210d847066$var$div($53143b210d847066$var$cls.element.thumb('y'));
    this.scrollbarYRail.appendChild(this.scrollbarY);
    this.scrollbarY.setAttribute('tabindex', 0);
    this.event.bind(this.scrollbarY, 'focus', focus);
    this.event.bind(this.scrollbarY, 'blur', blur);
    this.scrollbarYActive = null;
    this.scrollbarYHeight = null;
    this.scrollbarYTop = null;
    var railYStyle = $53143b210d847066$var$get(this.scrollbarYRail);
    this.scrollbarYRight = parseInt(railYStyle.right, 10);
    if (isNaN(this.scrollbarYRight)) {
        this.isScrollbarYUsingRight = false;
        this.scrollbarYLeft = $53143b210d847066$var$toInt(railYStyle.left);
    } else this.isScrollbarYUsingRight = true;
    this.scrollbarYOuterWidth = this.isRtl ? $53143b210d847066$var$outerWidth(this.scrollbarY) : null;
    this.railBorderYWidth = $53143b210d847066$var$toInt(railYStyle.borderTopWidth) + $53143b210d847066$var$toInt(railYStyle.borderBottomWidth);
    $53143b210d847066$var$set(this.scrollbarYRail, {
        display: 'block'
    });
    this.railYMarginHeight = $53143b210d847066$var$toInt(railYStyle.marginTop) + $53143b210d847066$var$toInt(railYStyle.marginBottom);
    $53143b210d847066$var$set(this.scrollbarYRail, {
        display: ''
    });
    this.railYHeight = null;
    this.railYRatio = null;
    this.reach = {
        x: element.scrollLeft <= 0 ? 'start' : element.scrollLeft >= this.contentWidth - this.containerWidth ? 'end' : null,
        y: element.scrollTop <= 0 ? 'start' : element.scrollTop >= this.contentHeight - this.containerHeight ? 'end' : null
    };
    this.isAlive = true;
    this.settings.handlers.forEach(function(handlerName) {
        return $53143b210d847066$var$handlers[handlerName](this$1);
    });
    this.lastScrollTop = Math.floor(element.scrollTop); // for onScroll only
    this.lastScrollLeft = element.scrollLeft; // for onScroll only
    this.event.bind(this.element, 'scroll', function(e) {
        return this$1.onScroll(e);
    });
    $53143b210d847066$var$updateGeometry(this);
};
$53143b210d847066$var$PerfectScrollbar.prototype.update = function update() {
    if (!this.isAlive) return;
    // Recalcuate negative scrollLeft adjustment
    this.negativeScrollAdjustment = this.isNegativeScroll ? this.element.scrollWidth - this.element.clientWidth : 0;
    // Recalculate rail margins
    $53143b210d847066$var$set(this.scrollbarXRail, {
        display: 'block'
    });
    $53143b210d847066$var$set(this.scrollbarYRail, {
        display: 'block'
    });
    this.railXMarginWidth = $53143b210d847066$var$toInt($53143b210d847066$var$get(this.scrollbarXRail).marginLeft) + $53143b210d847066$var$toInt($53143b210d847066$var$get(this.scrollbarXRail).marginRight);
    this.railYMarginHeight = $53143b210d847066$var$toInt($53143b210d847066$var$get(this.scrollbarYRail).marginTop) + $53143b210d847066$var$toInt($53143b210d847066$var$get(this.scrollbarYRail).marginBottom);
    // Hide scrollbars not to affect scrollWidth and scrollHeight
    $53143b210d847066$var$set(this.scrollbarXRail, {
        display: 'none'
    });
    $53143b210d847066$var$set(this.scrollbarYRail, {
        display: 'none'
    });
    $53143b210d847066$var$updateGeometry(this);
    $53143b210d847066$var$processScrollDiff(this, 'top', 0, false, true);
    $53143b210d847066$var$processScrollDiff(this, 'left', 0, false, true);
    $53143b210d847066$var$set(this.scrollbarXRail, {
        display: ''
    });
    $53143b210d847066$var$set(this.scrollbarYRail, {
        display: ''
    });
};
$53143b210d847066$var$PerfectScrollbar.prototype.onScroll = function onScroll(e) {
    if (!this.isAlive) return;
    $53143b210d847066$var$updateGeometry(this);
    $53143b210d847066$var$processScrollDiff(this, 'top', this.element.scrollTop - this.lastScrollTop);
    $53143b210d847066$var$processScrollDiff(this, 'left', this.element.scrollLeft - this.lastScrollLeft);
    this.lastScrollTop = Math.floor(this.element.scrollTop);
    this.lastScrollLeft = this.element.scrollLeft;
};
$53143b210d847066$var$PerfectScrollbar.prototype.destroy = function destroy() {
    if (!this.isAlive) return;
    this.event.unbindAll();
    $53143b210d847066$var$remove(this.scrollbarX);
    $53143b210d847066$var$remove(this.scrollbarY);
    $53143b210d847066$var$remove(this.scrollbarXRail);
    $53143b210d847066$var$remove(this.scrollbarYRail);
    this.removePsClasses();
    // unset elements
    this.element = null;
    this.scrollbarX = null;
    this.scrollbarY = null;
    this.scrollbarXRail = null;
    this.scrollbarYRail = null;
    this.isAlive = false;
};
$53143b210d847066$var$PerfectScrollbar.prototype.removePsClasses = function removePsClasses() {
    this.element.className = this.element.className.split(' ').filter(function(name) {
        return !name.match(/^ps([-_].+|)$/);
    }).join(' ');
};
var $53143b210d847066$export$2e2bcd8739ae039 = $53143b210d847066$var$PerfectScrollbar;


let $f442339011fc9894$export$9db0d5ae5b958e18 = [];
const $f442339011fc9894$export$b58c26e234731557 = ()=>{
    const windowWidth = window.innerWidth;
    const animatedSections = document.querySelectorAll('.animated-section');
    if (windowWidth > 1024) animatedSections.forEach((section)=>{
        const ps = new (0, $53143b210d847066$export$2e2bcd8739ae039)(section);
        $f442339011fc9894$export$9db0d5ae5b958e18.push(ps);
    });
    else $f442339011fc9894$export$9db0d5ae5b958e18.forEach((scrollbar)=>scrollbar.destroy());
};


const $1b599edd948128d1$var$modal = document.querySelector('.modal');
const $1b599edd948128d1$var$overlay = document.querySelector('.overlay');
const $1b599edd948128d1$var$closeButton = ()=>{
    const closeButton = document.createElement('button');
    closeButton.classList.add('close-modal');
    closeButton.innerHTML = '&times;';
    closeButton.addEventListener('click', $1b599edd948128d1$export$3f6fecd573f3fa48);
    return closeButton;
};
const $1b599edd948128d1$var$openCertificateModal = (imageUrl)=>{
    const imageElement = document.createElement('img');
    imageElement.alt = 'certificate';
    imageElement.className = 'udemy-cert';
    imageElement.src = imageUrl;
    $1b599edd948128d1$var$modal.appendChild($1b599edd948128d1$var$closeButton());
    $1b599edd948128d1$var$modal.appendChild(imageElement);
    $1b599edd948128d1$var$modal.classList.remove('hidden');
    $1b599edd948128d1$var$overlay.classList.remove('hidden');
};
const $1b599edd948128d1$export$ee7d958b9c647392 = (message, error = '')=>{
    const msg = document.createElement('p');
    msg.innerHTML = `${message} ${error}`;
    $1b599edd948128d1$var$modal.appendChild(msg);
    $1b599edd948128d1$var$modal.appendChild($1b599edd948128d1$var$closeButton());
    $1b599edd948128d1$var$modal.style.width = '70%';
    $1b599edd948128d1$var$modal.classList.remove('hidden');
    $1b599edd948128d1$var$overlay.classList.remove('hidden');
};
const $1b599edd948128d1$export$3f6fecd573f3fa48 = ()=>{
    $1b599edd948128d1$var$modal.innerHTML = '';
    $1b599edd948128d1$var$modal.classList.add('hidden');
    $1b599edd948128d1$var$overlay.classList.add('hidden');
    $1b599edd948128d1$var$modal.style.width = '90%'; // set modal window width back to original
};
const $1b599edd948128d1$export$e14d3bc873a8b9b1 = ()=>{
    document.querySelector('.certificates').addEventListener('click', (event)=>{
        const thumbnail = event.target.closest('.certi-logo');
        if (!thumbnail) return;
        $1b599edd948128d1$var$openCertificateModal(thumbnail.children[0].src);
    });
    $1b599edd948128d1$var$overlay.addEventListener('click', $1b599edd948128d1$export$3f6fecd573f3fa48);
    document.addEventListener('keydown', (e)=>{
        if (e.key === 'Escape' && !$1b599edd948128d1$var$modal.classList.contains('hidden')) $1b599edd948128d1$export$3f6fecd573f3fa48();
    });
};


const $4a210e80b1769c7c$var$certificates = [];
class $4a210e80b1769c7c$var$Certificate {
    #parentElement = document.querySelector(".certificates");
    #title;
    #completionDate;
    #imageUrl;
    constructor(title, completionDate, imageUrl){
        this.#title = title;
        this.#completionDate = completionDate;
        this.#imageUrl = imageUrl;
    }
    get completionDate() {
        return this.#completionDate;
    }
    #generateMarkup() {
        const formattedDate = this.#completionDate.toLocaleDateString("en-gb", {
            year: "numeric",
            month: "short",
            day: "numeric"
        });
        return `
            <div class="col-xs-12 col-sm-6">
                <div class="certificate-item clearfix">
                    <div class="certi-logo">
                        <img
                            class="certificate"
                            src="${this.#imageUrl}"
                            alt="certificate"
                        />
                    </div>
                    <div class="certi-content">
                        <div class="certi-title">
                            <h4>${this.#title}</h4>
                        </div>
                        <div class="certi-date">
                            <span>${formattedDate}</span>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
    render() {
        const markup = this.#generateMarkup();
        this.#parentElement.insertAdjacentHTML("beforeend", markup);
    }
}
var $dba1981c7461e464$exports = {};
$dba1981c7461e464$exports = import.meta.resolve("kGdQL");


var $d697a16de6cd5c6b$exports = {};
$d697a16de6cd5c6b$exports = import.meta.resolve("9vFna");


var $59a84b24e4a89341$exports = {};
$59a84b24e4a89341$exports = import.meta.resolve("fD3BX");


var $1b93979de73842fe$exports = {};
$1b93979de73842fe$exports = import.meta.resolve("eNMh3");


var $13837eb0325ed75c$exports = {};
$13837eb0325ed75c$exports = import.meta.resolve("dc7wS");


var $bc489f6e7ea9eae3$exports = {};
$bc489f6e7ea9eae3$exports = import.meta.resolve("9u34O");


var $91d78e8057460da9$exports = {};
$91d78e8057460da9$exports = import.meta.resolve("d4uJ8");


var $1b070e0b8705cfad$exports = {};
$1b070e0b8705cfad$exports = import.meta.resolve("9Kwss");


var $f5e9a523ca94f9b9$exports = {};
$f5e9a523ca94f9b9$exports = import.meta.resolve("cTjDz");


var $01441d5a540fda2e$exports = {};
$01441d5a540fda2e$exports = import.meta.resolve("kvpKu");


const $4a210e80b1769c7c$var$populateCertificates = ()=>{
    $4a210e80b1769c7c$var$certificates.push(new $4a210e80b1769c7c$var$Certificate("NGINX Fundamentals: High Performance Servers from Scratch", new Date("2021/02/29"), new URL($dba1981c7461e464$exports)), new $4a210e80b1769c7c$var$Certificate("Apache Kafka Series - Learn Apache Kafka for Beginners v2", new Date("2019/05/08"), new URL($d697a16de6cd5c6b$exports)), new $4a210e80b1769c7c$var$Certificate("Learn Visual Studio Code (2020)", new Date("2021/10/11"), new URL($59a84b24e4a89341$exports)), new $4a210e80b1769c7c$var$Certificate("Apache Maven: Beginner to Guru", new Date("2021/12/11"), new URL($1b93979de73842fe$exports)), new $4a210e80b1769c7c$var$Certificate("Kotin for Java Developers", new Date("2021/12/23"), new URL($13837eb0325ed75c$exports)), new $4a210e80b1769c7c$var$Certificate("The Complete JavaScript Course 2022", new Date("2022/02/16"), new URL($bc489f6e7ea9eae3$exports)), new $4a210e80b1769c7c$var$Certificate("MongoDB - The Complete Developer's Guide 2022", new Date("2022/05/28"), new URL($91d78e8057460da9$exports)), new $4a210e80b1769c7c$var$Certificate("Cypress: Web Automation Testing from Zero to Hero", new Date("2022/07/05"), new URL($1b070e0b8705cfad$exports)), new $4a210e80b1769c7c$var$Certificate("Vim Masterclass", new Date("2022/07/17"), new URL($f5e9a523ca94f9b9$exports)), new $4a210e80b1769c7c$var$Certificate("Reactive Programming with Spring Framework 5", new Date("2024/01/02"), new URL($01441d5a540fda2e$exports)));
    $4a210e80b1769c7c$var$certificates.sort((a, b)=>b.completionDate - a.completionDate);
    $4a210e80b1769c7c$var$certificates.forEach((certificate)=>certificate.render());
};
function $4a210e80b1769c7c$export$2e2bcd8739ae039() {
    $4a210e80b1769c7c$var$populateCertificates();
    (0, $1b599edd948128d1$export$e14d3bc873a8b9b1)();
}


function $0d07f2cf61f752c2$export$2e2bcd8739ae039(number) {
    switch(number){
        case 0:
            return [
                'animated-section-moveFromTopFade',
                'animated-section-rotateFoldBottom'
            ];
        case 1:
            return [
                'animated-section-moveFromRight animated-section-ontop',
                'animated-section-scaleDown'
            ];
        case 2:
            return [
                'animated-section-moveFromTop',
                'animated-section-moveToBottom'
            ];
        case 3:
            return [
                'animated-section-moveFromTopFade',
                'animated-section-moveToBottomFade'
            ];
    }
}



class $e222bed21241d7db$export$2e2bcd8739ae039 {
    #classMap = new Map();
    #currentPageMap = new Map();
    #animEndEventName = 'animationend';
    #isAnimating = false;
    #endCurrentPage = true;
    #endNextPage = false;
    #transitionNumber = 0;
    constructor(transitionNumber){
        this.#transitionNumber = transitionNumber;
        const start = this.#getStartMenuItem();
        this.#activeMenuItem(start);
        this.#populateClassMap();
        this.#initMenuItems();
        this.#animate(start);
    }
    #getStartMenuItem = ()=>{
        const pageStart = this.#getActiveSectionName();
        const homePage = document.querySelectorAll('.nav-anim');
        const start = Array.from(homePage).find((element)=>element.getAttribute('href').slice(1) === pageStart);
        return start;
    };
    #activeMenuItem = (page)=>{
        if (!page) return false;
        const menu = document.querySelectorAll('.nav-anim');
        menu.forEach((child)=>child.classList.remove('active'));
        page.classList.toggle('active');
    };
    #populateClassMap = ()=>{
        const sections = document.querySelectorAll('.animated-section');
        sections.forEach((section)=>{
            this.#classMap.set(section.dataset.id, [
                ...section.classList
            ]);
            if (section.dataset.id === this.#getActiveSectionName()) {
                section.classList.add('section-active');
                this.#currentPageMap.set('current', section.dataset.id);
            }
        });
    };
    #getActiveSectionName = ()=>{
        // if no active page then start with start page
        if (location.hash === '') {
            const start = document.querySelector('.start-page');
            location.hash = start.dataset.id;
            return location.hash.slice(1);
        } else return location.hash.slice(1);
    };
    #initAnimate = (item)=>{
        if (this.#isAnimating) return false;
        this.#activeMenuItem(item);
        (0, $1b599edd948128d1$export$3f6fecd573f3fa48)();
        this.#animate(item);
        location.hash = item.getAttribute('href');
    };
    #initMenuItems = ()=>{
        const navigation = document.querySelectorAll('.nav-anim');
        navigation.forEach((menuItem)=>{
            menuItem.addEventListener('click', this.#initAnimate.bind(this, menuItem));
        });
    };
    #animateCurrentPage = (currentPage, nextPage)=>{
        this.#endCurrentPage = true;
        if (this.#endNextPage) {
            this.#onEndAnimation(nextPage, currentPage);
            this.#endCurrentPage = false;
        }
    };
    #animateNextPage = (currentPage, nextPage)=>{
        this.#endNextPage = true;
        if (this.#endCurrentPage) {
            this.#onEndAnimation(nextPage, currentPage);
            this.#endNextPage = false;
            this.#isAnimating = false;
        }
    };
    #onEndAnimation = (nextPage, currentPage)=>{
        currentPage.classList = '';
        const currentPageOriginalClassList = this.#classMap.get(currentPage.dataset.id);
        currentPage.classList.add(...currentPageOriginalClassList);
        nextPage.classList = '';
        const nextPageOriginalClassList = this.#classMap.get(nextPage.dataset.id);
        nextPage.classList.add(...nextPageOriginalClassList);
        nextPage.classList.add('section-active');
    };
    #animate = (page)=>{
        const [a, b] = (0, $0d07f2cf61f752c2$export$2e2bcd8739ae039)(this.#transitionNumber);
        const inClass = a.split(' ');
        const outClass = b.split(' ');
        let currentPageId = this.#currentPageMap.get('current');
        let gotoPage = page?.getAttribute('href').slice(1);
        let tempPageIndex = currentPageId;
        // Current page to be removed.
        const currentPage = document.querySelector('[data-id=' + `${currentPageId}` + ']');
        // NEXT PAGE
        currentPageId = gotoPage;
        // Check if the current page is same as the next page then do not do the animation
        // else reset the 'isAnimatiing' flag
        if (tempPageIndex != currentPageId) {
            this.#isAnimating = true;
            this.#currentPageMap.set('current', currentPageId);
            // Next page to be animated.
            const nextPage = document.querySelector('[data-id=' + `${currentPageId}` + ']');
            nextPage.classList.add('section-active');
            nextPage.scrollTop = 0;
            currentPage.classList.add(outClass);
            currentPage.addEventListener(this.#animEndEventName, this.#animateCurrentPage.bind(this, currentPage, nextPage), {
                once: true
            });
            nextPage.classList.add(...inClass);
            nextPage.addEventListener(this.#animEndEventName, this.#animateNextPage.bind(this, currentPage, nextPage), {
                once: true
            });
        } else this.#isAnimating = false;
    };
}


const $77ac944da51b7354$var$printCopyright = ()=>{
    const date = new Date();
    const year = date.getFullYear();
    const copyright = document.querySelector('.copyrights');
    copyright.textContent = `\xa9 2022-${year} All rights reserved.`;
};
const $77ac944da51b7354$var$getTransitionEffectNumber = ()=>Math.floor(Math.random() * 4);
const $77ac944da51b7354$var$loadWindowAndResize = ()=>{
    window.onload = ()=>{
        const ptPage = document.querySelector('.animated-sections');
        if (ptPage) new (0, $e222bed21241d7db$export$2e2bcd8739ae039)($77ac944da51b7354$var$getTransitionEffectNumber());
    };
    window.onresize = ()=>{
        (0, $f442339011fc9894$export$9db0d5ae5b958e18).forEach((scrollbar)=>scrollbar.update());
    };
};
$77ac944da51b7354$var$printCopyright();
(0, $4a210e80b1769c7c$export$2e2bcd8739ae039)();
(0, $f442339011fc9894$export$b58c26e234731557)();
$77ac944da51b7354$var$loadWindowAndResize();


//# sourceMappingURL=website.1177c22f.js.map
